// Weighted + bucketed ranges. ENGINE_DESIGN.md §1 (schema/range.ts), §4.4.
import { z } from 'zod';
import { CardStringSchema } from './primitives';
/** Weighted range over the 1326 hold'em combos. weights[idx] ∈ [0,1]; 0 = not in range.
 *  Always paired with its removal state. Typed arrays validated by instance + length. */
export const WeightedRangeSchema = z.object({
    weights: z
        .instanceof(Float32Array)
        .refine((a) => a.length === 1326, { message: 'weights must be length 1326' }),
    /** combos zeroed by dead cards (board + known holes); kept for display. */
    removed: z.instanceof(Uint16Array),
});
export const RANGE_BUCKETS = ['value', 'strongDraw', 'weakDraw', 'showdown', 'air', 'trap'];
export const RangeBucketSchema = z.enum(RANGE_BUCKETS);
export const BucketedRangeSchema = z.object({
    buckets: z.record(RangeBucketSchema, z.object({
        combos: z.number().nonnegative(),
        pctOfRange: z.number().min(0).max(100),
        /** representative combos, each as a pair of card strings, e.g. [["As","Ks"], ...]. */
        top: z.array(z.array(CardStringSchema)),
    })),
});
//# sourceMappingURL=range.js.map